import { InjectionToken } from '@angular/core';
import { TutorialButtonRef } from './tutorial-button-ref';
import { TutorialButtonComponent } from './tutorial-button/tutorial-button.component';

export const TUTORIAL_PANEL_DATA = new InjectionToken('TUTORIAL_PANEL_DATA');

export class TutorialPanelRef {
  constructor(private tutorialButtonComponent: TutorialButtonComponent, private buttonRef: TutorialButtonRef) {}

  public closePanel() {
    this.tutorialButtonComponent.panelOpen = false;
  }

  public openPanel() {
    this.tutorialButtonComponent.panelOpen = true;
  }

  public togglePanel() {
    this.tutorialButtonComponent.togglePanel();
  }

  public remove() {
    this.buttonRef.close();
  }
}
